import { Box, Typography } from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import {
  GridToolbar,
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarDensitySelector,
  GridToolbarFilterButton,
} from "@mui/x-data-grid";
import "../../Switcher.scss";
import { useDispatch, useSelector } from "react-redux";
import { getAdminCallActive } from "../../redux/actions/adminPortal_callActiveAction";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";
import PhoneDisabledIcon from "@mui/icons-material/PhoneDisabled";
import { toast } from "react-toastify";
import axios from "axios";
import { api } from "../../mockData";
import { StyledDataGrid } from "../../pages/CustomDataGrid";
import dayjs from "dayjs";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Table, Button } from "react-bootstrap";
import PageTitle from "../common/PageTitle";

const drawerWidth = 240;

const useStyles = makeStyles({
  borderedGreen: {
    borderLeft: "3px solid green",
    boxShadow: "2px -1px 4px -3px #686868",
    margin: "4px 4px 1px 4px !important",
  },
  borderedRed: {
    borderLeft: "3px solid red",
    boxShadow: "2px -1px 4px -3px #686868",
    margin: "4px 4px 1px 4px !important",
  },
  formControl: {
    "& .MuiInputBase-root": {
      color: "#666",
      borderColor: "transparent",
      borderWidth: "1px",
      borderStyle: "solid",
      height: "45px",
      minWidth: "120px",
      justifyContent: "center",
    },
    "& .MuiSelect-select.MuiSelect-select": {
      paddingRight: "0px",
    },
    "& .css-14s5rfu-MuiFormLabel-root-MuiInputLabel-root": {
      top: "-4px !important",
    },
  },
  select: {
    width: "auto",
    fontSize: "12px",
    "&:focus": {
      backgroundColor: "transparent",
    },
  },
  selectIcon: {
    position: "relative",
    color: "#6EC177",
    fontSize: "14px",
  },
  paper: {
    borderRadius: 12,
    marginTop: 8,
  },
});

const theme = createTheme({
  components: {
    MuiDataGrid: {
      styleOverrides: {
        root: {
          "& .MuiDataGrid-row": {
            minHeight: "auto",
          },
        },
      },
      defaultProps: {
        density: "compact",
      },
    },
  },
});

export function CustomFooterStatusComponent(props) {
  return <></>;
}

function CustomToolbar() {
  return (
    <GridToolbarContainer>
      <GridToolbarColumnsButton />
      <GridToolbarDensitySelector />
      <GridToolbarFilterButton />
    </GridToolbarContainer>
  );
}

function AdminCallActive({ colorThem }) {
  const dispatch = useDispatch();
  const state = useSelector((state) => state);
  const [timeDifference, setTimeDifference] = useState({});
  const [sortConfig, setSortConfig] = useState({ key: null, direction: null });

  // useEffect(() => {
  dispatch(getAdminCallActive());
  // }, [dispatch]);

  const handleHangup = async (data) => {
    const token = JSON.parse(localStorage.getItem("admin"));
    let values = JSON.stringify({
      CallReference: data.CallReference,
    });
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token.access_token} `,
        },
      };
      const { data } = await axios.post(
        `${api.dev}/api/callhangup`,
        values,
        config,
      );
      if (data?.status === 200) {
        toast.success(data?.message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1500,
        });
      } else {
        toast.error(data?.message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2500,
        });
      }
    } catch (error) {
      toast.error(error?.response?.data?.message, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 2500,
      });
    }
  };

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isXs = useMediaQuery(theme.breakpoints.only("xs"));
  const isSmallScreen = useMediaQuery(theme.breakpoints.between("sm"));

  // Main data fetch and parse
  const mockDataTeam = useMemo(() => {
    if (state?.getAdminCallActive?.callactive !== undefined) {
      const parsedData = Object.keys(state?.getAdminCallActive?.callactive)
        .map((key) => {
          try {
            const parsedValue = JSON.parse(
              state?.getAdminCallActive?.callactive[key],
            );
            return {
              id: key,
              ...parsedValue,
            };
          } catch (error) {
            console.error(`Failed to parse JSON for key: ${key}`, error);
            return null;
          }
        })
        .filter(Boolean);

      // Sort data by TimeStamp in descending order
      return parsedData.sort((a, b) => {
        const dateA = dayjs(a.TimeStamp);
        const dateB = dayjs(b.TimeStamp);
        return dateB - dateA;
      });
    }
    return [];
  }, [state?.getAdminCallActive?.callactive]);

  // Function to calculate time differences for each timestamp
  const calculateTimeDifferences = () => {
    const now = new Date();
    const diffMap = {};

    mockDataTeam.forEach((row) => {
      const ts = new Date(row.TimeStamp);
      const diff = now - ts;
      const sec = Math.floor(Math.max(0, diff / 1000)); // Ensure non-negative
      const min = Math.floor(sec / 60);
      const hr = Math.floor(min / 60);

      diffMap[row.id] = {
        hours: String(hr).padStart(2, "0"),
        minutes: String(min % 60).padStart(2, "0"),
        seconds: String(sec % 60).padStart(2, "0"),
        totalSeconds: sec, // Store total seconds for sorting
      };
    });

    setTimeDifference(diffMap);
  };

  // Calculate time differences initially and update every second
  useEffect(() => {
    if (mockDataTeam.length > 0) {
      calculateTimeDifferences();
    }

    const interval = setInterval(() => {
      if (mockDataTeam.length > 0) {
        calculateTimeDifferences();
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [mockDataTeam]);

  // ---------------- Columns ------------------
  const columns1 = [
    { key: "sno", label: "S.No", textAlign: "center", sortable: false },
    { key: "DIDNumber", label: "Did Number", sortable: true },
    { key: "CallerID", label: "Caller Id", sortable: true },
    { key: "Username", label: "Username", sortable: true },
    { key: "CompaignName", label: "Campaign Name", sortable: true },
    {
      key: "BuyerName",
      label: "Buyer Name",
      width: 180,
      minWidth: 150,
      sortable: true,
    },
    { key: "ForwardedTo", label: "Forwarded To", sortable: true },
    { key: "Status", label: "Status", sortable: true },
    {
      key: "CallDuration",
      label: "Call Duration",
      width: 130,
      textAlign: "center",
      sortable: true,
    },
    { key: "DateStamp", label: "Date", sortable: true },
    { key: "TimeStamp", label: "Time", sortable: true },
    { key: "hangup", label: "Hangup", textAlign: "center", sortable: false },
  ];

  // ---------------- Sorting ------------------
  const handleSort = (columnKey) => {
    const column = columns1.find((col) => col.key === columnKey);
    if (!column?.sortable) return; // Don't sort if column is not sortable

    if (sortConfig.key === columnKey) {
      if (sortConfig.direction === "asc") {
        setSortConfig({ key: columnKey, direction: "desc" });
      } else if (sortConfig.direction === "desc") {
        setSortConfig({ key: null, direction: null });
      } else {
        setSortConfig({ key: columnKey, direction: "asc" });
      }
    } else {
      setSortConfig({ key: columnKey, direction: "asc" });
    }
  };

  const getSortIcon = (columnKey) => {
    const column = columns1.find((col) => col.key === columnKey);
    if (!column?.sortable) return null;

    const isActive = sortConfig.key === columnKey;
    const direction = sortConfig.direction;
    let iconClass = "fa-solid ";

    if (!isActive) iconClass += "fa-sort";
    else if (direction === "asc") iconClass += "fa-arrow-up";
    else if (direction === "desc") iconClass += "fa-arrow-down";

    return (
      <i
        className={iconClass}
        style={{
          opacity: isActive && direction ? 1 : 0.3,
          transition: "opacity 0.3s ease",
          color: isActive ? "#f5751D" : "#aaa",
          marginLeft: "5px",
          fontSize: "12px",
        }}
      ></i>
    );
  };

  // Helper function to get duration in seconds for sorting
  const getDurationSeconds = (row) => {
    const duration = timeDifference[row.id];
    if (!duration) return 0;

    // For DIALING status, return 0
    if (row.Status === "DIALING") return 0;

    return duration.totalSeconds || 0;
  };

  const sortedData = useMemo(() => {
    if (!sortConfig.key) return mockDataTeam;

    const dir = sortConfig.direction === "asc" ? 1 : -1;

    return [...mockDataTeam].sort((a, b) => {
      // Special handling for CallDuration sorting
      if (sortConfig.key === "CallDuration") {
        const aSeconds = getDurationSeconds(a);
        const bSeconds = getDurationSeconds(b);
        return (aSeconds - bSeconds) * dir;
      }

      // Handle date sorting
      if (sortConfig.key === "DateStamp" || sortConfig.key === "TimeStamp") {
        const aTime = new Date(a.TimeStamp).getTime();
        const bTime = new Date(b.TimeStamp).getTime();
        return (aTime - bTime) * dir;
      }

      // Handle string sorting for other columns
      let av = a[sortConfig.key];
      let bv = b[sortConfig.key];

      av = String(av ?? "").toLowerCase();
      bv = String(bv ?? "").toLowerCase();

      if (av < bv) return -1 * dir;
      if (av > bv) return 1 * dir;
      return 0;
    });
  }, [mockDataTeam, sortConfig, timeDifference]);

  return (
    <>
      <div className={`App ${colorThem} `}>
        <div className="contant_box">
          <Box
            className="right_sidebox mobile_top_pddng"
            component="main"
            sx={{
              flexGrow: 1,
              p: 3,
              width: { sm: `calc(100% - ${drawerWidth}px)` },
            }}
          >
            <div className="col-lg-12">
              <div className="">
                <div className="tab-content" id="pills-tabContent">
                  <div
                    className="tab-pane fade show active"
                    id="pills-home"
                    role="tabpanel"
                    aria-labelledby="pills-home-tab"
                  >
                    <div className="cntnt_title">
                      <div className="">
                        <PageTitle title="Active Calls" />
                      </div>
                    </div>

                    <div className="table-wrapper">
                      <div className="scroll-top">
                        <div
                          className="scroll-inner"
                          style={{ width: "100%", overflowX: "auto" }}
                         >
                          <Table
                            hover
                            size="sm"
                            bordered
                            className="call-active-table border-1 table-striped"
                            style={{ minWidth: "1100px" }} // 👈 important for horizontal scroll
                          >
                            <tr className="active-table-head">
                              {columns1.map((col) => (
                                <th
                                  key={col.key}
                                  onClick={() => handleSort(col.key)}
                                  style={{
                                    cursor: col.sortable
                                      ? "pointer"
                                      : "default",
                                    userSelect: "none",
                                    textAlign: col.textAlign || "left",
                                    position: "relative",
                                  }}
                                >
                                  <span>{col.label}</span>
                                  <span className="sortingicon">
                                    {getSortIcon(col.key)}
                                  </span>
                                </th>
                              ))}
                            </tr>

                            <tbody>
                              {sortedData.length === 0 ? (
                                <tr>
                                  <td
                                    colSpan={columns1.length}
                                    className="text-center text-muted"
                                  >
                                    No active calls found
                                  </td>
                                </tr>
                              ) : (
                                sortedData.map((row, index) => {
                                  const duration = timeDifference[row.id];
                                  const date = new Date(row.TimeStamp);
                                  const formattedDate = `${String(date.getDate()).padStart(2, "0")}/${String(
                                    date.getMonth() + 1,
                                  ).padStart(2, "0")}/${date.getFullYear()}`;
                                  const formattedTime = `${String(date.getHours()).padStart(2, "0")}:${String(
                                    date.getMinutes(),
                                  ).padStart(
                                    2,
                                    "0",
                                  )}:${String(date.getSeconds()).padStart(2, "0")}`;

                                  return (
                                    <tr key={row.id}>
                                      <td className="text-center">
                                        {index + 1}
                                      </td>
                                      <td>
                                      {row.DIDNumber
                                        ? String(row.DIDNumber).startsWith("+1")
                                          ? row.DIDNumber
                                          : String(row.DIDNumber).startsWith("1")
                                          ? `+${row.DIDNumber}`
                                          : `+1${row.DIDNumber}`
                                        : "-"}
                                    </td>
                                      <td>{row.CallerID || "-"}</td>
                                      <td>{row.Username || "-"}</td>
                                      <td>{row.CompaignName || "-"}</td>
                                      <td>{row.BuyerName || "-"}</td>
                                      <td>{row.ForwardedTo || "-"}</td>
                                      <td>
                                        <span
                                          style={{
                                            color:
                                              row.Status === "ANSWER" ||
                                              row.Status === "BUYER_ANSWERED"
                                                ? "green"
                                                : row.Status === "RINGING"
                                                  ? "skyblue"
                                                  : row.Status === "DIALING"
                                                    ? "violet"
                                                    : "grey",
                                            fontWeight: 500,
                                          }}
                                        >
                                          {row.Status || "-"}
                                        </span>
                                      </td>
                                      <td
                                        style={{
                                          color:
                                            row.Status === "DIALING"
                                              ? "grey"
                                              : "green",
                                          textAlign: "center",
                                          fontWeight: 600,
                                        }}
                                      >
                                        {duration && row.Status !== "DIALING"
                                          ? `${duration.hours}:${duration.minutes}:${duration.seconds}`
                                          : "00:00:00"}
                                      </td>
                                      <td>
                                        <span style={{ color: "blue" }}>
                                          {formattedDate}
                                        </span>
                                      </td>
                                      <td>
                                        <span style={{ color: "green" }}>
                                          {formattedTime}
                                        </span>
                                      </td>

                                      <td className="text-center">
                                        {row.Status === "BUYER_ANSWERED" && (
                                          <Button
                                            size="sm"
                                            variant="outline-danger"
                                            onClick={() => handleHangup(row)}
                                            style={{
                                              padding: "2px 8px",
                                              borderColor: "#dc3545",
                                              color: "#dc3545",
                                            }}
                                            onMouseEnter={(e) => {
                                              e.target.style.backgroundColor =
                                                "#dc3545";
                                              e.target.style.color = "white";
                                            }}
                                            onMouseLeave={(e) => {
                                              e.target.style.backgroundColor =
                                                "transparent";
                                              e.target.style.color = "#dc3545";
                                            }}
                                          >
                                            <PhoneDisabledIcon fontSize="small" />
                                          </Button>
                                        )}
                                      </td>
                                    </tr>
                                  );
                                })
                              )}
                            </tbody>
                          </Table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Box>
        </div>
      </div>
    </>
  );
}

export default AdminCallActive;
